import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEdit = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "18px",
	height: "18px",
	viewBox: "0 0 18 18",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "Shape" }),
		/* @__PURE__ */ _jsx("desc", { children: "Created with Sketch." }),
		/* @__PURE__ */ _jsx("g", {
			id: "Wireframes-Mobile-Agent-Yulia",
			stroke: "none",
			strokeWidth: 1,
			fill: "none",
			fillRule: "evenodd",
			children: /* @__PURE__ */ _jsx("g", {
				id: "Home---Messages---Profil",
				transform: "translate(-332.000000, -380.000000)",
				fill: "#7A7A7A",
				fillRule: "nonzero",
				children: /* @__PURE__ */ _jsx("path", {
					d: "M332,394.250521 L332,398 L335.749479,398 L346.807943,386.941536 L343.058464,383.192057 L332,394.250521 Z M349.707541,384.041939 C350.097486,383.651993 350.097486,383.02208 349.707541,382.632134 L347.367866,380.292459 C346.97792,379.902514 346.348007,379.902514 345.958061,380.292459 L344.128316,382.122205 L347.877795,385.871684 L349.707541,384.041939 Z",
					id: "Shape"
				})
			})
		})
	]
});
export default SvgEdit;
